<template>
  <div class="item">
    <div class="item__main">
      <div class="item__column">
        <p class="item__column-text">{{ order.humanReadableId }}</p>
      </div>
      <div class="item__column">
        <p>{{ dayjs(order.buyTime).format('MMM D YYYY HH:mm') }}</p>
      </div>
      <div class="item__column">
        <p>{{ order.status }}</p>
      </div>
      <div class="item__column">
        <p><span>€{{ order.totalPrice }}</span>  {{ t('profile.orders.forNItems', { quantity: allItemsInOrder }) }}</p>
      </div>
      <div class="item__column">
        <ui-button class="item__button" @click="isOrderOpen = !isOrderOpen">{{ isOrderOpen ? t('buttons.close') : t('buttons.view') }}</ui-button>
      </div>
    </div>
    <div class="item__block" :class="[{active: isOrderOpen}]">
      <div class="item__block-wrapper">
        <product-card-in-order
            class="item__product"
            v-for="(product, idx) of order.orderProducts.edges"
            :key="idx"
            :product="product.node"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import dayjs from "dayjs";
import UiButton from "@/components/ui/ui-button.vue";
import {useI18n} from "vue-i18n";
import {computed, ref} from "vue";
import ProductCardInOrder from "@/components/cards/product-card-in-order.vue";

const props = defineProps({
  order: Object
})

const {t} = useI18n()

const allItemsInOrder = computed(() => {
  if (!props.order?.orderProducts?.edges) return 0;

  return props.order.orderProducts.edges.reduce((total, edge) => {
    return total + (edge.node.quantity || 0);
  }, 0);
});

const isOrderOpen = ref(false)
</script>

<style lang="scss" scoped>
.item {
  border-bottom: 2px solid #E4E4E4;

  &__main {
    display: flex;
    align-items: center;
    padding-block: 14px;
  }

  &__column {
    &:nth-child(1) {
      width: 15%;
    }
    &:nth-child(2) {
      width: 30%;
    }
    &:nth-child(3) {
      width: 18%;
    }
    &:nth-child(4) {
      width: 30%;
    }
    &:nth-child(5) {
      width: 10%;
      display: flex;
      justify-content: flex-end;
    }

    & p {
      color: #555;
      font-size: 14px;
      font-weight: 400;
      line-height: 25.6px;

      & span {
        color: #2F2F2F;
        font-weight: 700;
      }
    }

    &-text {
      color: #2F2F2F !important;
      font-weight: 500 !important;
    }
  }

  &__button {
    width: fit-content;
    padding: 10px 15px;
    font-size: 16px;
  }

  &__block {
    display: grid;
    grid-template-rows: 0fr;
    transition: grid-template-rows 0.2s ease;
    overflow: hidden;

    &.active {
      grid-template-rows: 1fr;
    }

    & > * {
      min-height: 0;
    }
  }
}
</style>